import React from 'react'
import './FooterStyle.css'
import flogb from '../../assets/images/flo-gb.svg'
import logo from '../../assets/images/logo.png'
import LanguageIcon from '../../assets/images/Language.svg'
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import { useTranslation } from 'react-i18next';


const FooterSection = () => {
  const { t } = useTranslation();
    return (
     
       <footer className="footer">
        <div className="container-fluid d-flex">
          <span className="d-block text-center text-sm-start d-sm-inline-block">
            
            {/* {t('dashboard.copyright')} */}
          </span>
          <span className="float-none float-sm-end mt-1 mt-sm-0 text-end ms-2"><a href="#" target="_blank">{t('dashboard.privacyPolicy')}</a> <a href="#" target="_blank" className="ms-2">{t('dashboard.Sitemap')}</a></span>
        </div>
      </footer>
    
    )
}

export default FooterSection
